module.exports = __webpack_public_path__ + "img/moblie-no-data.215bc5e8.png";